import { vSafeHref, vSafeSrc, vSafeAction, vSafeStyle, vSafeClass } from "@/plugins/directives/safeDirectives";

export default {
  install(app: any) {
    app.directive("safe-href", vSafeHref);
    app.directive("safe-src", vSafeSrc);
    app.directive("safe-action", vSafeAction);
    app.directive("safe-style", vSafeStyle);
    app.directive("safe-class", vSafeClass);
  }
};
